import { render, staticRenderFns } from "./ServiceMenuIcon.vue?vue&type=template&id=71c0fa1c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports